import React, { useEffect, useState } from "react";
import { Formik, FormikConsumer, useFormik } from "formik";
// import * as Yup from "yup";
import {
  TextField,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Box,
  Autocomplete,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "../../../components/common/Card";
import { addFuelPurchase, GetFuelDetails } from "../../../services/FuelService";
import { toast } from "react-toastify";
import { withErrorHandler } from "../../../utils/tryCatchHandler";
import {
  getShiftDetails1,
  getSiteDetails,
  getVendorDetails,
  saveVehicleDetails,
  saveVendorDetails,
  vehicleTypes,
} from "../../../services/vehicleService";
import { VolunteerActivismOutlined } from "@mui/icons-material";
import moment from "moment";
import axios from "axios";
const AddVendorComponent = () => {
  const [fuelList, setFuelList] = useState([]);
  const [sitesList, setSitesLsit] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [activeTab, setActiveTab] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [frequencyList, setFrequency] = useState([
    "Hourly",
    "Daily",
    "Monthly",
  ]);

  const [filefields, setFileFields] = useState([
    {
      fieldName: "Pan Card",
      type: "3",
      fieldValue: "panCard",
      sequence: 1,
      file: null,
      className: "mt-1",
    },
    {
      fieldName: "Aadhaar Card",
      type: "2",
      fieldValue: "adhaar",
      sequence: 2,
      file: null,
      className: "mt-1",
    },
    {
      fieldName: "Cancelled Cheque",
      type: "1",
      fieldValue: "cancelledCheque",
      sequence: 3,
      file: null,
      className: "mt-2",
    },
    {
      fieldName: "GST file",
      type: "4",
      fieldValue: "gstFile",
      sequence: 4,
      file: null,
      className: "mt-2",
    },
    {
      fieldName: "Agreement",
      type: "3",
      fieldValue: "agreement",
      sequence: 5,
      file: null,
      className: "mt-2",
    },
  ]);

  const [vendorList, setVendorList] = useState([]);

  // const  []
  const formik = useFormik({
    initialValues: {
      name: "",
      contactPerson: "",
      contactNumber: "",
      email: "",
      address: "",
      accountNumber: "",
      holderName: "",
      bankName: "",
      branchName: "",
      ifsc: "",
      gstNumber: "",
      panNumber: "",
      adhaarNumber: "",
      advance: "",
      // agreementStartDate: "",
      agreementEndDate: "",
      siteId: 0,
    },
        onReset: (initialValues) => ({
      values: { initialValues },
    }),
    onSubmit: async (values) => {
      let formdata = new FormData();

      Object.keys(values).forEach((x) => {
        if (values[x]) {
          if (!x.includes("State") && !x.includes("Date")) {
            formdata.append(x, values[x]);
          }
          if (x.includes("Date")) {
            let value = values[x] + " 00:00:00";
            formdata.append(x, value);
          }
        }
      });
      console.log(formdata);
      filefields.forEach((x) => {
        formdata.append(x.fieldValue, x.file);
      });

      // formdata.append("bankName", "sdfsdjffsd");

      try {
        await saveVendorDetails(formdata)
          .then((res) => {
            // console.log(JSON.parse(res.data));

            const response = res.data;
            console.log(response);

            if (response?.statusDescription?.statusCode == 200) {
              toast.success(response?.statusDescription?.description);

              let e;
              let arr = [];

              filefields.forEach((x) => {
                x.file = null;
                arr.push(x);
              });
              setFileFields(arr);

              formik.handleReset(e);
            } else {
              toast.warn(response?.statusDescription?.description);
            }
          })
          .catch((err) => {});
      } catch (e) {
        console.log(e);
      }
    },
  });

  useEffect(() => {
    getAllDetails();
  }, []);

  const getAllDetails = async () => {
    await getSites()
      .then(getShiftDetails)
      .then(getVehiclees)
      .then(getVendorDetail)
      .then((data) => {});
  };

  const getVendorDetail = async () => {
    withErrorHandler(
      await getVendorDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          console.log(res.data);
          setVendorList(res.data.vendorDetailList);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };

  const getSites = async () => {
    setSitesLsit([]);
    withErrorHandler(
      await getSiteDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          // console.log(res.data);
          setSitesLsit(res.data.siteDetails);
          // formik.setFieldValue("siteIdState", []);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };
  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setVehicleList(res.data.data);

          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(res.data.data[0].name);
            setActiveId(res.data.data[0].vehicleTypeId);
          }
        } else {
        }
      })
    );
  };

  const getShiftDetails = async () => {
    setShiftList([]);
    withErrorHandler(
      await getShiftDetails1().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setShiftList(res.data.shiftDetails);
          // formik.setFieldValue("shiftState", res.data.shiftDetails);
          // formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);
          // formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);
        } else {
        }
      })
    );
  };

  /**
   * Compresses a list of image files using specified options
   * @example
   * handleCompression([file1, file2, file3])
   * Returns a list of compressed File objects with reduced size
   * @param {Array} {files} - Array of File objects representing the images to be compressed.
   * @returns {Promise<Array>} Returns a promise that resolves to an array of compressed File objects.
   * @description
   *   - Utilizes web workers for compression to optimize performance.
   *   - Ensures compressed files maintain original file types.
   *   - Handles resizing of images if dimensions exceed defined thresholds.
   *   - Applies asynchronous iteration over input files for compression.
   */
  const handleCompression = async (files) => {
    const options = {
      maxSizeMB: 1, // max size in MB
      maxWidthOrHeight: 1024, // resize if larger
      useWebWorker: true,
    };
    console.log(files);
    const compressedList = await Promise.all(
      files.map(async (file) => {
        const compressed = await imageCompression(file, options);
        return new File([compressed], file.name, {
          type: compressed.type,
        });
      })
    );
    console.log(compressedList);
    return compressedList;
  };

  return (
    <Card title={"Add Vendor Details"}>
      <Box className="container mt-4">
        <form onSubmit={formik.handleSubmit} className="mt-4">
          {/* <div className="row mb-2">
            <div className="col-md-4 col-12  mb-2">
              <Autocomplete
                options={sitesList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                multiple
                // sx={{ width: 300 }}
                value={formik.values.siteIdState || []}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.siteName || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("siteIdState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("siteIdState", newValue);
                    console.log(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Sites`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={shiftList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                multiple
                // sx={{ width: 300 }}
                value={formik.values.shiftState || []}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("shiftState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("shiftState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Shift`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={vendorList || []}
                size="small"
                className="inp_search"
                label={"Vendor"}
                // sx={{ width: 300 }}
                value={formik.values.vendorState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("vendorState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("vendorState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Vendor`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={vehicleList || []}
                size="small"
                className="inp_search1"
                label={"Vendor"}
                // sx={{ width: 300 }}
                value={formik.values.vehicleState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("vehicleState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("vehicleState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Vehicle Type`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Make"
                name="make"
                size="small"
                value={formik.values.make}
                onChange={formik.handleChange}
                required
                error={formik.touched.make && Boolean(formik.errors.make)}
                helperText={
                  formik.touched.vehicleNumber && formik.errors.vehicleNumber
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Model "
                name="modelNo"
                size="small"
                value={formik.values.modelNo}
                onChange={formik.handleChange}
                required
                error={formik.touched.make && Boolean(formik.errors.make)}
                helperText={
                  formik.touched.vehicleNumber && formik.errors.vehicleNumber
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Vehicle Number"
                name="vehicleNumber"
                size="small"
                value={formik.values.vehicleNumber}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.vehicleNumber &&
                  Boolean(formik.errors.vehicleNumber)
                }
                helperText={
                  formik.touched.vehicleNumber && formik.errors.vehicleNumber
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={frequencyList || []}
                size="small"
                className="inp_search2"
                label={"Frequency"}
                // sx={{ width: 300 }}
                value={formik.values.frequency || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("frequency", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("frequency", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Frequency`}
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Rate"
                name="rate"
                size="small"
                required
                value={formik.values.rate}
                onChange={formik.handleChange}
                error={formik.touched.rate && Boolean(formik.errors.rate)}
                helperText={formik.touched.rate && formik.errors.rate}
              />
            </div>
          </div> */}

          <div className="row mb-2">
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Supplier Name"
                name="name"
                size="small"
                value={formik.values.name}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Contact Person"
                name="contactPerson"
                size="small"
                value={formik.values.contactPerson}
                onChange={formik.handleChange}
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Contact Number"
                name="contactNumber"
                size="small"
                value={formik.values.contactNumber}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Email"
                name="email"
                size="small"
                value={formik.values.email}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Address"
                name="address"
                size="small"
                value={formik.values.address}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Account Number"
                name="accountNumber"
                size="small"
                value={formik.values.accountNumber}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Account Holder Name"
                name="holderName"
                size="small"
                value={formik.values.holderName}
                onChange={formik.handleChange}
                required
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Bank Name"
                name="bankName"
                size="small"
                value={formik.values.bankName}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Branch Name"
                name="branchName"
                size="small"
                value={formik.values.branchName}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="IFSC Code"
                name="ifsc"
                size="small"
                value={formik.values.ifsc}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="GST Number"
                name="gstNumber"
                size="small"
                value={formik.values.gstNumber}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="PAN Number"
                name="panNumber"
                size="small"
                value={formik.values.panNumber}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Aadhaar Number"
                name="adhaarNumber"
                size="small"
                value={formik.values.adhaarNumber}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Advance"
                name="advance"
                size="small"
                value={formik.values.advance}
                onChange={formik.handleChange}
                required
              />
            </div>
            {/* <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Agreement Start Date"
                name="agreementStartDate"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={formik.values.agreementStartDate}
                onChange={formik.handleChange}
                required
              />
            </div> */}

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Agreement End Date"
                name="agreementEndDate"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={formik.values.agreementEndDate}
                onChange={formik.handleChange}
                required
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={sitesList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                // sx={{ width: 300 }}
                value={formik.values.siteIdState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.siteName || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("siteIdState", null);
                    formik.setFieldValue("siteId", null);
                  }
                  if (newValue) {
                    formik.setFieldValue("siteIdState", newValue);
                    formik.setFieldValue("siteId", newValue.siteId);
                    console.log(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Sites`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>

            {filefields.map((field) => {
              return (
                <>
                  <div className={"col-md-4 col-12 mb-2 " + field.className}>
                    <TextField
                      name="uploadfiles"
                      className="inp_choose"
                      type={"file"}
                      label={field.fieldName}
                      inputProps={{
                        multiple: true,
                        style: { padding: "8.5px 14px" },
                        accept: "image/*",
                        capture: "environment",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        let files = Array.from(e.target.files[0]);
                        let fieldArray = [];
                        filefields.forEach((x, i) => {
                          if (x.fieldName == field.fieldName) {
                            x.file = e.target.files[0];
                          }
                          fieldArray.push(x);
                        });
                        setFileFields(fieldArray);
                      }}
                    />
                  </div>
                </>
              );
            })}
          </div>

          <div className="row">
            <div className="col-12 text-end d-flex justify-content-end">
              <Button
                type="reset"
                onClick={(e) => {
                  formik.handleReset(e);
                }}
                variant="contained"
                className="clr_btn me-3"
                color="secondary"
              >
                Clear
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="yellow_btn_1"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </Box>
    </Card>
  );
};

export default AddVendorComponent;
